<template>
  <v-app>
	<navbar v-if="$route.name !== 'login' && $route.name !== 'choose-page'"></navbar>
	<div v-if="loading" class="h-100 m-auto d-flex justify-center align-center">
		<v-progress-circular
			indeterminate
			color="primary"
		></v-progress-circular>
	</div>
    <v-main v-if="!loading">
      <router-view/>
    </v-main>

	<!-- snackbar -->
	<v-snackbar
		v-model="snackbar"
		app
		transition="slide-y-reverse-transition"
		:color="
			(state === 'info' ? 'primary': '') +
			(state === 'warn' ? 'warning': '') +
			(state === 'error' ? 'red lighten-1': '') + ' white--text'
		"
	>
		{{ message }}

		<template v-slot:action>
			<v-btn
				color="white"
				icon
				@click="snackbar = false"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</template>
	</v-snackbar>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar.vue'
import { MD5 } from 'crypto-js'
import { onForegroundMessage } from '@/plugins/firebase'
export default {
	name: 'App',

	components: {
		Navbar
	},

	data: () => ({
		loading: false,
		snackbar: false,
		message: '',
		state: null
	}),

	methods: {
		MD5,
		getAllData () {
			// state.auth.core / state.auth.bus / state.transport.tripId are already hydrated from
			// localStorage by main.js before the app mounts - just gate the route here
			if (!localStorage.getItem('coreAuth') && this.$route.name !== 'login') {
				this.$router.replace({ name: 'login' })
			}
			this.loading = false
		}
	},

	created () {
		this.getAllData()
		this.$eventBus.$on('show-snackbar', (message, state = 'info') => {
            this.message = message
            this.state = state
            this.snackbar = true
        })
		onForegroundMessage((payload) => {
			const { title, body } = payload.notification || {}
			this.$eventBus.$emit('show-snackbar', body || title || 'إشعار جديد', 'info')
		})
	}
}
</script>

<style lang="scss">
html, body {
    margin: 0;
    padding: 0;
    height: 100%
}

@font-face {
	font-family: cocon_next_arabic;
	src: url('@/assets/cocon_next_arabic.ttf');
	font-weight: 100 300;
}
#app {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
}

html, body {
	margin: 0;
    height: 100%;
	font-family: cocon_next_arabic;
}

* {
	font-family: cocon_next_arabic;
}

.h-100 {
    height: 100%
}

.w-100 {
	width: 100%
}

.rounded-BigLg {
	border-radius: 12px !important
}

.fs-sm {
	font-size: 13px;
	line-height: 1.1
}
</style>
